export default __webpack_public_path__ + "static/media/(40).9261c8f4.jpg";